import { render } from "./add-breaches-modal.html?vue&type=template&id=0a53aa28&scoped=true&ts=true&external"
import script from "./add-breaches-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-breaches-modal.ts?vue&type=script&lang=ts&external"

import "./add-breaches-modal.scss?vue&type=style&index=0&id=0a53aa28&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a53aa28"]])

export default __exports__